import './App.scss';
import HomePage from './Pages/HomePage';
import AboutPage from './Pages/AboutPage';
import PortfliosPage from './Pages/PortfoliosPage';
import ContactPage from './Pages/ContactPage';
import SecretLetterPage from './Pages/SecretLetterPage';

function App() {
  const secretLetterPaths = ['/carta-devs', '/secret-letter'];
  const isSecretLetter = secretLetterPaths.includes(window.location.pathname);

  if (isSecretLetter) {
    return <SecretLetterPage />;
  }

  return (
    <div className="App">
      <div className="main-content">
        <main className="content">
          <section id="home" className="page-section page-section-hero">
            <HomePage />
          </section>
          <section id="about" className="page-section">
            <AboutPage />
          </section>
          <section id="projects" className="page-section">
            <PortfliosPage />
          </section>
          <section id="contact" className="page-section">
            <ContactPage />
          </section>
        </main>
      </div>
    </div>
  );
}

export default App;
